import { Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { HomeService } from 'src/app/services/home/home.service';
import { StoresService } from 'src/app/services/stores/stores.service';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
	selector: 'app-pandora-wish',
	templateUrl: './pandora-wish.component.html',
	styleUrls: ['./pandora-wish.component.css'],
})
export class PandoraWishComponent implements OnInit {
	@Input() height: number = 0;
	images: any[] = [];
	banners: any = {
		header: [],
		middle: [],
		end: [],
		lastSection: [],
	};
	products: any[] = [];
	isAuth: boolean = false;
	@Input() oneImg: boolean = false;
	@ViewChild('video_header') video_header: ElementRef;
	DEFAULT_PHOTO: string = 'https://puu.sh/ImNRs/0ab1b352dc.png';
	showvideoHome: boolean = false;
	videoUrl: string = '';
	id_store: string = '';

	private subscriptions: Array<Subscription> = [];

	constructor(private homeservice: HomeService, private auth: AuthService, private stores: StoresService, private homeService: HomeService, @Inject(PLATFORM_ID) private platformID) {}

	ngOnInit(): void {
		this.checkAuth();
	}

	ngAfterViewInit() {
		// Llama al método play() después de que la vista y los elementos hayan sido inicializados
		if (this.video_header != undefined) {
			const video: HTMLVideoElement = this.video_header.nativeElement;
			video.play();
		}
	}
	ngOnDestroy(): void {
		this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
	}

	checkAuth() {
		// this.auth.isAuthenticated() ? (this.isAuth = true) : (this.isAuth = false)
		this.getImageBanner();
		this.getId();
		this.getConfig();
		this.getHome();
	}

	getId() {
		this.stores.getStoreId().subscribe(async (id) => {
			if (id !== null && id !== 'null') {
				this.id_store = id;
			}
		});
	}
	getHome() {
		this.homeservice.getHome(this.id_store).then((res) => {
			if (JSON.parse(res.data.home)) {
				let { slidersHeader, slidersMiddle, slidersEnd, lastSection } = JSON.parse(res.data.home);
				this.banners = {
					header: slidersHeader,
					middle: slidersMiddle,
					end: slidersEnd,
					lastSection: lastSection ? lastSection : [],
				};
				if (isPlatformBrowser(this.platformID)) {
					localStorage.setItem('banners', JSON.stringify(this.banners.header));
				}
				this.homeService.setImage(this.banners.header);
        this.updateImages(window.innerWidth); // Update images based on screen width
				// this.imgs = imagenes

				window.scrollTo(0, 0);
			}
			let { videoUrl } = JSON.parse(res.data.home);
			this.videoUrl = videoUrl;
		});
	}

	getConfig() {
		// this.stores.getConfig()
		// .subscribe(configuraciones=> {
		//     if(configuraciones.length > 0){
		//     configuraciones.map(item =>{
		//       if(item.name === 'showvideohome'){
		//         this.showvideoHome = item.value === 'true'
		//       }
		//     })
		// }
		// })

		this.stores.getConfiguracion(this.id_store).then((res) => {
			let configuraciones = res.data;
			if (configuraciones.length > 0) {
				configuraciones.map((item) => {
					if (item.name === 'showvideohome') {
						this.showvideoHome = item.value === 'true';
					}
				});
			}
		});
	}

	getImageBanner() {
		this.homeservice.getImage().subscribe((img) => (this.images = img));
	}

	// Function to update the images based on screen width
	updateImages(width: number) {
		if (width < 640) {
			this.images = this.banners.middle.length > 0 ? this.banners.middle : this.banners.header;
		} else {
			this.images = this.banners.header;
		}
	}

	// HostListener to react to window resize
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.updateImages(event.target.innerWidth);
	}
}
